import { ComponentProps } from "react";

export function DottedSpinner(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      fill="none"
      {...props}
    >
      <g
        clipPath="url(#clip0_7444_2848)"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="var(--color-primary-500)"
      >
        <path
          opacity={0.33}
          d="M30.256.828l-1.034 3.859a20.304 20.304 0 00-1.71-.376 20.308 20.308 0 00-1.736-.239L26.14.094a24.168 24.168 0 014.116.734z"
        />
        <path
          opacity={0.38}
          d="M36.045 3.232l-2.009 3.461a18.895 18.895 0 00-3.15-1.476l1.371-3.757c1.327.48 2.59 1.081 3.788 1.772z"
        />
        <path
          opacity={0.42}
          d="M41.01 7.064l-2.84 2.815a20.12 20.12 0 00-2.665-2.253l2.31-3.265a24.551 24.551 0 013.194 2.703z"
        />
        <path
          opacity={0.5}
          d="M44.805 12.037l-3.464 1.993a20.5 20.5 0 00-1.988-2.864l3.068-2.56a23.569 23.569 0 012.384 3.431z"
        />
        <path
          opacity={0.55}
          d="M47.206 17.828l-3.87 1.027c-.297-1.13-.7-2.228-1.185-3.269l3.623-1.69a24.55 24.55 0 011.432 3.932z"
        />
        <path
          opacity={0.6}
          d="M48.005 24.046l-4-.013a20.147 20.147 0 00-.295-3.475l3.94-.679c.237 1.352.362 2.756.355 4.167z"
        />
        <path
          opacity={0.65}
          d="M47.626 28.214c-.123.69-.275 1.373-.455 2.042l-3.867-1.045c.15-.552.28-1.118.384-1.699.104-.58.178-1.167.229-1.737l3.988.366c-.06.68-.154 1.374-.279 2.073z"
        />
        <path
          opacity={0.7}
          d="M46.542 32.246a23.662 23.662 0 01-1.774 3.798l-3.461-2.01a19.903 19.903 0 001.478-3.159l3.757 1.371z"
        />
        <path
          opacity={0.75}
          d="M43.642 37.803A23.565 23.565 0 0140.94 41l-2.817-2.83c.817-.819 1.575-1.71 2.243-2.667l3.277 2.301z"
        />
        <path
          opacity={0.8}
          d="M39.385 42.407a23.57 23.57 0 01-3.424 2.397L33.97 41.34a20.494 20.494 0 002.855-2l2.561 3.067z"
        />
        <path
          opacity={0.95}
          d="M34.103 45.773a23.635 23.635 0 01-3.93 1.421l-1.039-3.862c1.131-.306 2.228-.7 3.28-1.192l1.689 3.633z"
        />
        <path d="M28.123 47.641a23.822 23.822 0 01-4.169.364l.013-4a20.758 20.758 0 003.466-.296l.69 3.932z" />
        <path
          opacity={0.05}
          d="M21.86 47.906a24.149 24.149 0 01-4.115-.734l1.035-3.869c.562.151 1.128.283 1.709.386.58.104 1.157.176 1.737.229l-.366 3.988z"
        />
        <path
          opacity={0.07}
          d="M17.116 42.783l-1.371 3.758a23.813 23.813 0 01-3.786-1.783l2.007-3.451a20.778 20.778 0 003.15 1.476z"
        />
        <path
          opacity={0.09}
          d="M12.496 40.364l-2.309 3.266a23.637 23.637 0 01-3.197-2.693l2.84-2.826a20.12 20.12 0 002.666 2.254z"
        />
        <path
          opacity={0.11}
          d="M8.649 36.824l-3.067 2.56a23.565 23.565 0 01-2.385-3.431l3.464-1.993a20.498 20.498 0 001.988 2.864z"
        />
        <path
          opacity={0.13}
          d="M5.85 32.414l-3.621 1.68a23.56 23.56 0 01-1.432-3.932l3.87-1.027c.297 1.13.7 2.228 1.183 3.279z"
        />
        <path
          opacity={0.15}
          d="M4.29 27.433l-3.942.688a23.66 23.66 0 01-.352-4.177l4 .013c-.007 1.177.1 2.344.294 3.476z"
        />
        <path
          opacity={0.17}
          d="M4.31 20.488c-.104.581-.177 1.157-.228 1.727l-3.99-.356a24.179 24.179 0 01.735-4.115l3.868 1.036c-.15.552-.282 1.128-.386 1.708z"
        />
        <path
          opacity={0.19}
          d="M6.694 13.955a20.156 20.156 0 00-1.478 3.16L1.46 15.744c.48-1.326 1.083-2.6 1.772-3.788l3.463 2z"
        />
        <path
          opacity={0.21}
          d="M9.879 9.83c-.815.81-1.573 1.7-2.242 2.658L4.36 10.187a24.551 24.551 0 012.703-3.195L9.88 9.83z"
        />
        <path
          opacity={0.25}
          d="M14.03 6.65a20.493 20.493 0 00-2.856 2l-2.56-3.068a23.568 23.568 0 013.423-2.396L14.03 6.65z"
        />
        <path
          opacity={0.28}
          d="M18.867 4.658c-1.131.306-2.227.7-3.28 1.193l-1.69-3.623A24.55 24.55 0 0117.829.796l1.038 3.862z"
        />
        <path
          opacity={0.3}
          d="M24.035 3.995a18.896 18.896 0 00-3.466.296L19.881.349a23.795 23.795 0 014.166-.354l-.012 4z"
        />
      </g>
      <defs>
        <clipPath id="clip0_7444_2848">
          <path fill="#fff" d="M0 0H48V48H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
